import React, { useEffect, useMemo, useState } from "react";
import ReactDOM from "react-dom";
import { ToastManager, ToastOptions } from "./ToastManager";
import { ToastContainer, ToastContent, ToastPosition, ToastGroupContainer, CloseButton } from "./style";
import Icon from "../../../atoms/Icon";

interface Toast extends ToastOptions {
  id: string;
  isExiting: boolean;
  style?: React.CSSProperties;
}

const ToastPopup: React.FC = () => {
  const [toasts, setToasts] = useState<Toast[]>([]);

  useEffect(() => {
    const handleChange = (state: { toasts: Toast[] }) => {
      setToasts(state.toasts);
    };

    ToastManager.addListener(handleChange);
    return () => ToastManager.removeListener(handleChange);
  }, []);

  const handleClose = (e: React.MouseEvent, id: string) => {
    e.stopPropagation();
    ToastManager.setExiting(id);
    setTimeout(() => {
      ToastManager.remove(id);
    }, 300);
  };

  // position별로 토스트 그룹핑
  const groupedToasts = useMemo(() => {
    const groups = new Map<ToastPosition, Toast[]>();
    for (const toast of toasts) {
      const pos = (toast.position as ToastPosition) || "top";
      if (!groups.has(pos)) groups.set(pos, []);
      groups.get(pos)!.push(toast);
    }
    return groups;
  }, [toasts]);

  if (toasts.length === 0) return null;

  return ReactDOM.createPortal(
    <>
      {Array.from(groupedToasts.entries()).map(([position, group]) => (
        <ToastGroupContainer key={position} position={position}>
          {group.map((toast) => (
            <ToastContainer
              key={toast.id}
              position={position}
              isExiting={toast.isExiting}
              onClick={() => {
                if (toast.onClick) {
                  toast.onClick();
                  ToastManager.setExiting(toast.id);
                  setTimeout(() => ToastManager.remove(toast.id), 300);
                }
              }}
              hasClickHandler={!!toast.onClick}
              style={toast.style}
            >
              <ToastContent>
                {typeof toast.content === "string" ? <span>{toast.content}</span> : toast.content}
              </ToastContent>
              <CloseButton onClick={(e) => handleClose(e, toast.id)}>
                <Icon name="X" size={16} />
              </CloseButton>
            </ToastContainer>
          ))}
        </ToastGroupContainer>
      ))}
    </>,
    document.body
  );
};

export default ToastPopup;
